/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DatabaseIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "database", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M18.5 7C18.5 8.45543 15.8137 9.5 12.5 9.5C9.18629 9.5 6.5 8.45543 6.5 7C6.5 5.54457 9.18629 4.5 12.5 4.5C15.8137 4.5 18.5 5.54457 18.5 7Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M18.5 7V17.5C18.5 19.0594 16.0504 20.5 12.5 20.5C8.9496 20.5 6.5 19.0594 6.5 17.5V7", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DatabaseIcon);
export default ForwardRef;
//# sourceMappingURL=databaseIcon.js.map